// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "appointment_deposit_refund".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "appointment_deposit_refund" table (1:1 with a DB row, on the wire). */
export const appointmentDepositRefundAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    depositId: z.string(),
    allocationId: z.string().nullable(),
    operationKey: z.string(),
    allocationSlices: z.unknown(),
    amountCents: z.number(),
    status: z.string(),
    stripeRefundId: z.string().nullable(),
    failureCode: z.string().nullable(),
    providerAttemptedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=appointmentDepositRefund.js.map